// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";

var $$Response = {};

function use() {
  var match = React.useState(function () {
        return false;
      });
  var setSupportMode = match[1];
  React.useEffect((function () {
          var fetchSupportMode = async function () {
            var params = {
              method: "GET",
              credentials: "include"
            };
            try {
              var response = await globalThis.fetch(process.env.LP_URL + "/support_mode", params);
              var data = await response.json();
              return Curry._1(setSupportMode, (function (param) {
                            return data.support_mode;
                          }));
            }
            catch (exn){
              return Curry._1(setSupportMode, (function (param) {
                            return false;
                          }));
            }
          };
          fetchSupportMode();
        }), []);
  return match[0];
}

export {
  $$Response ,
  use ,
}
/* react Not a pure module */
